import React, { Component } from 'react';
import stringUtils from '../../utils/string';
import { AuthenticationLoginPreload } from './AuthenticationLoginPreload';
import AuthenticationContainer from './components/AuthenticationContainer';
import AuthenticationTiles from './components/AuthenticationTiles';
import AuthenticationActionSwitcher from './decorators/authenticationActionSwitcher';
import AuthenticationInitialDataController from './decorators/authenticationInitialDataController';

@AuthenticationInitialDataController
@AuthenticationActionSwitcher
class Authentication extends Component {
	render() {
		const { currentFormByActionType, isPending, authenticationInitialData } = this.props;
		const hasTiles = !stringUtils.isNullOrEmpty(authenticationInitialData.tiles);

		return (
			<>
				{isPending && <AuthenticationLoginPreload />}
				{!isPending && (
					<>
						<AuthenticationContainer>{currentFormByActionType}</AuthenticationContainer>
						{hasTiles && <AuthenticationTiles tiles={authenticationInitialData.tiles} />}
					</>
				)}
			</>
		);
	}
}

export { Authentication };
